import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  changedItem(event) {
    var tag = event.target.value;
    // first clear old selections
    var text_block = this.inputTarget
    for (let i = 0; i < text_block.getElementsByTagName('span').length; i++) {
      text_block.getElementsByTagName('span')[i].className = '';
    }
    // then update to new selection
    var selection = window.getSelection();
    selection.modify('extend', 'backward', 'wordboundary');
    selection.modify('extend', 'forward', 'wordboundary');
    var range = selection.getRangeAt(0);
    var newNode = document.createElement("span");
    newNode.setAttribute('class', tag)
    newNode.appendChild(range.extractContents());
    range.insertNode(newNode);
  }
}
